import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import FeaturedReviews from '../components/FeaturedReviews';
import Categories from '../components/Categories';
import Editorial from '../components/Editorial';
import StarsSection from '../components/StarsSection';
import SeriesSection from '../components/SeriesSection';
import Ecosystem from '../components/Ecosystem';

const HomePage = () => {
  return (
    <div className="bg-[#0B0F0E] min-h-screen">
      <Header />
      <main>
        <Hero />
        <FeaturedReviews />
        <Categories />
        <SeriesSection />
        <StarsSection />
        <Editorial />
        <Ecosystem />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
